import { render, staticRenderFns } from "./CoreMenuDivider.vue?vue&type=template&id=09c73251&scoped=true&"
import script from "./CoreMenuDivider.vue?vue&type=script&lang=js&"
export * from "./CoreMenuDivider.vue?vue&type=script&lang=js&"
import style0 from "./CoreMenuDivider.vue?vue&type=style&index=0&id=09c73251&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09c73251",
  null
  
)

export default component.exports